<template>
  <div class="howto-container">
    <ul :class="classname" aria-label="Anleitung">
      <li class="first" aria-label="1. Schritt: Markt auswählen">
        <div class="icon"></div>
        <div class="todo mobile"><small>1. Schritt</small><span>Markt auswählen</span></div>
        <div class="todo desktop">1. Markt auswählen</div>
      </li>
      <li class="second" aria-label="2. Schritt: Merkliste erstellen">
        <div class="icon"></div>
        <div class="todo mobile"><small>2. Schritt</small><span>Merkliste erstellen</span></div>
        <div class="todo desktop">2. Merkliste erstellen</div>
      </li>
      <li class="third" aria-label="3. Schritt: Im Markt einkaufen">
        <div class="icon"></div>
        <div class="todo mobile"><small>3. Schritt</small><span> Markt einkaufen</span></div>
        <div class="todo desktop">3. Im Markt einkaufen</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      classname: "showFirst",
      switchInterval: 3500
    };
  },
  mounted() {
    this.switchClassname();
  },
  methods: {
    switchClassname() {
      setTimeout(() => {
        if (this.classname === "showFirst") {
          this.classname = "showSecond";
        } else if (this.classname === "showSecond") {
          this.classname = "showThird";
        } else {
          this.classname = "showFirst";
        }
        this.switchClassname();
      }, this.switchInterval);
    }
  },
  computed: {
    ...mapGetters(["isMobile"])
  }
};
</script>

<style lang="scss">
@import "./HowTo";
</style>